module.exports = __webpack_public_path__ + "img/s4.4b594a04.jpg";